import type { ReduxApplicationState } from '../combinedReducer';

export const selectAccessibility = (state: ReduxApplicationState) => state.accessibility;
